module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.influencer) ? _c('div', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.openExpansion),
      callback: function($$v) {
        _vm.openExpansion = $$v
      },
      expression: "openExpansion"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Contact Information *")]), _vm._v(" "), _c('v-expansion-panel-content', [(_vm.influencer.facebook) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Facebook Handle"
    },
    model: {
      value: (_vm.influencer.facebook.handle),
      callback: function($$v) {
        _vm.$set(_vm.influencer.facebook, "handle", $$v)
      },
      expression: "influencer.facebook.handle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.twitter) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "X (Twitter) Handle"
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function() {
        return [_c('img', {
          staticClass: "mr-2",
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "20px",
            "alt": "",
            "aria-hidden": "true"
          }
        })]
      },
      proxy: true
    }], null, false, 2464317665),
    model: {
      value: (_vm.influencer.twitter.twitterHandle),
      callback: function($$v) {
        _vm.$set(_vm.influencer.twitter, "twitterHandle", $$v)
      },
      expression: "influencer.twitter.twitterHandle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasFirstName) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "First Name",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.influencer.firstName),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "firstName", $$v)
      },
      expression: "influencer.firstName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasLastName) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Last Name"
    },
    model: {
      value: (_vm.influencer.lastName),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "lastName", $$v)
      },
      expression: "influencer.lastName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Email Address",
      "required": "",
      "rules": _vm.MessageRules
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "input": _vm.removeSpaces,
      "paste": _vm.preventPasteSpaces
    },
    model: {
      value: (_vm.influencer.email),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "email", $$v)
      },
      expression: "influencer.email"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Contact Number"
    },
    model: {
      value: (_vm.influencer.phone),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "phone", $$v)
      },
      expression: "influencer.phone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Billing Information")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Country",
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "name"
    },
    on: {
      "change": _vm.changeCountry
    },
    model: {
      value: (_vm.influencer.country),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "country", $$v)
      },
      expression: "influencer.country"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.bankNames,
      "label": "Bank Name (select your bank)",
      "item-text": "bank",
      "item-value": "bank",
      "search-input": _vm.newBankName,
      "attach": "",
      "disabled": _vm.disableBankSelect
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newBankName = $event
      },
      "update:search-input": function($event) {
        _vm.newBankName = $event
      },
      "change": _vm.changeBankName
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [(_vm.newBankName) ? _c('span', {
          staticClass: "subheading pr-2"
        }, [_vm._v(_vm._s(_vm.newBankName))]) : _vm._e()])]
      },
      proxy: true
    }], null, false, 2535767177),
    model: {
      value: (_vm.influencer.bankName),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "bankName", $$v)
      },
      expression: "influencer.bankName"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('################'),
      expression: "'################'"
    }],
    staticClass: "purple-input",
    attrs: {
      "label": "Bank Account Number (Please omit dash '-')"
    },
    model: {
      value: (_vm.influencer.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "bankAccount", $$v)
      },
      expression: "influencer.bankAccount"
    }
  }), _vm._v(" "), _c('span')], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Swift Code"
    },
    model: {
      value: (_vm.swiftCode),
      callback: function($$v) {
        _vm.swiftCode = $$v
      },
      expression: "swiftCode"
    }
  }), _vm._v(" "), _c('span')], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Fullname as per Bank Account Name"
    },
    model: {
      value: (_vm.influencer.fullName),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "fullName", $$v)
      },
      expression: "influencer.fullName"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Street Address"
    },
    model: {
      value: (_vm.influencer.mailingAddress),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "mailingAddress", $$v)
      },
      expression: "influencer.mailingAddress"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Postal Code"
    },
    model: {
      value: (_vm.influencer.postalCode),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "postalCode", $$v)
      },
      expression: "influencer.postalCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_c('p', [_vm._v("Your rates\n            "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(in SGD per item)")])])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "IG Static",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.inputedRates.igStatic),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "igStatic", _vm._n($$v))
      },
      expression: "influencer.inputedRates.igStatic"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "IG Carousel",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.inputedRates.igCarousel),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "igCarousel", _vm._n($$v))
      },
      expression: "influencer.inputedRates.igCarousel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "IG Story",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.inputedRates.igStory),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "igStory", _vm._n($$v))
      },
      expression: "influencer.inputedRates.igStory"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "IG TV",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.inputedRates.igTv),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "igTv", _vm._n($$v))
      },
      expression: "influencer.inputedRates.igTv"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Tiktok",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.inputedRates.tiktok),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "tiktok", _vm._n($$v))
      },
      expression: "influencer.inputedRates.tiktok"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Blog",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.inputedRates.blog),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "blog", _vm._n($$v))
      },
      expression: "influencer.inputedRates.blog"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_vm._v("\n            Pricing Decks:\n              "), _c('v-btn', {
    staticClass: "ma-5 white--text",
    attrs: {
      "color": "blue-grey"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.mediaUpload.click()
      }
    }
  }, [_vm._v("\n              Upload\n              "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("\n                mdi-cloud-upload\n              ")])], 1), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "media",
      "id": "fileToUpload",
      "accept": "image/*, .pdf, .ppt, .txt, .doc, .docx"
    },
    on: {
      "change": _vm.prepareUpload
    }
  }), _vm._v(" "), _c('div', [(_vm.images.length > 0) ? _c('v-row', _vm._l((_vm.images), function(img, index) {
    return _c('v-col', {
      key: index,
      staticClass: "d-flex child-flex",
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "2",
        "lg": "1"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [_c('v-card', {
            staticClass: "d-flex",
            attrs: {
              "flat": "",
              "tile": "",
              "elevation": hover ? 16 : 2
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": img.url,
              "lazy-src": img.url,
              "aspect-ratio": "1"
            }
          }), _vm._v(" "), _c('v-overlay', {
            attrs: {
              "absolute": ""
            }
          }, [_c('v-btn', {
            attrs: {
              "dark": "",
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteImage(index)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "dark": "",
              "color": "red"
            }
          }, [_vm._v("cancel")])], 1)], 1)], 1)]
        }
      }], null, true)
    })], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.decksFiles.length > 0) ? _c('v-row', _vm._l((_vm.decksFiles), function(item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "2",
        "lg": "1",
        "align": "center"
      }
    }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "./static/img/pdf.png",
        "aspect-ratio": "1"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "./static/img/ppt.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "./static/img/doc.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "./static/img/text.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "dark": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "color": "red"
      }
    }, [_vm._v("cancel")])], 1)], 1)
  }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_c('v-textarea', {
    staticClass: "purple-input",
    attrs: {
      "filled": "",
      "auto-grow": "",
      "label": "Remark",
      "placeholder": "If you have any thoughts on your rates, please let us know here."
    },
    model: {
      value: (_vm.influencer.inputedRates.remark),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "remark", $$v)
      },
      expression: "influencer.inputedRates.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Additional")]), _vm._v(" "), _c('v-expansion-panel-content', [(_vm.influencer.xiaohongshu && _vm.isMainPlatform('xiaohongshu')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Followers",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.xiaohongshu.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.influencer.xiaohongshu, "totalFollowers", $$v)
      },
      expression: "influencer.xiaohongshu.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.xiaohongshu && _vm.isMainPlatform('xiaohongshu')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Following",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.xiaohongshu.totalFollowing),
      callback: function($$v) {
        _vm.$set(_vm.influencer.xiaohongshu, "totalFollowing", $$v)
      },
      expression: "influencer.xiaohongshu.totalFollowing"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.xiaohongshu && _vm.isMainPlatform('xiaohongshu')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Likes/Favourites",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.xiaohongshu.totalLikesFavourites),
      callback: function($$v) {
        _vm.$set(_vm.influencer.xiaohongshu, "totalLikesFavourites", $$v)
      },
      expression: "influencer.xiaohongshu.totalLikesFavourites"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.facebook && _vm.isMainPlatform('facebook')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Followers",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.facebook.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.influencer.facebook, "totalFollowers", $$v)
      },
      expression: "influencer.facebook.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.facebook && _vm.isMainPlatform('facebook')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Following",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.facebook.totalFollowing),
      callback: function($$v) {
        _vm.$set(_vm.influencer.facebook, "totalFollowing", $$v)
      },
      expression: "influencer.facebook.totalFollowing"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.linkedin && _vm.isMainPlatform('linkedin')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Followers (Connections)",
      "type": "number",
      "min": "0"
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function() {
        return [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "color": "#0A66C2",
            "small": ""
          }
        }, [_vm._v("mdi-linkedin")])]
      },
      proxy: true
    }], null, false, 2884666817),
    model: {
      value: (_vm.influencer.linkedin.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.influencer.linkedin, "totalFollowers", _vm._n($$v))
      },
      expression: "influencer.linkedin.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.twitter && _vm.isMainPlatform('twitter')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "X (Twitter) Followers",
      "type": "number",
      "min": "0"
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function() {
        return [_c('img', {
          staticClass: "mr-2",
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "20px",
            "alt": "",
            "aria-hidden": "true"
          }
        })]
      },
      proxy: true
    }], null, false, 2464317665),
    model: {
      value: (_vm.influencer.twitter.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.influencer.twitter, "totalFollowers", _vm._n($$v))
      },
      expression: "influencer.twitter.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.twitter && _vm.isMainPlatform('twitter')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "X (Twitter) Following",
      "type": "number",
      "min": "0"
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function() {
        return [_c('img', {
          staticClass: "mr-2",
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "20px",
            "alt": "",
            "aria-hidden": "true"
          }
        })]
      },
      proxy: true
    }], null, false, 2464317665),
    model: {
      value: (_vm.influencer.twitter.totalFollowing),
      callback: function($$v) {
        _vm.$set(_vm.influencer.twitter, "totalFollowing", _vm._n($$v))
      },
      expression: "influencer.twitter.totalFollowing"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Gender",
      "items": _vm.userGender_options,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.influencer.gender),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "gender", $$v)
      },
      expression: "influencer.gender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Your Birthday",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.influencer.birthday),
            callback: function($$v) {
              _vm.$set(_vm.influencer, "birthday", $$v)
            },
            expression: "influencer.birthday"
          }
        }, on))]
      }
    }], null, false, 472973793),
    model: {
      value: (_vm.bdPicker),
      callback: function($$v) {
        _vm.bdPicker = $$v
      },
      expression: "bdPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.bdPicker = false
      }
    },
    model: {
      value: (_vm.influencer.birthday),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "birthday", $$v)
      },
      expression: "influencer.birthday"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Ethnicity",
      "items": _vm.ethnicity_options,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.influencer.ethnicity),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "ethnicity", $$v)
      },
      expression: "influencer.ethnicity"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Occupation"
    },
    model: {
      value: (_vm.influencer.occupation),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "occupation", $$v)
      },
      expression: "influencer.occupation"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_c('label', [_vm._v("Preferred type of campaigns/genre (please tick relevant)")]), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "secondary white--text",
      "max": "3",
      "column": ""
    },
    model: {
      value: (_vm.influencer.keywords),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "keywords", $$v)
      },
      expression: "influencer.keywords"
    }
  }, _vm._l((_vm.categories), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-5 pr-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "id": "btn-save-change",
      "color": "green"
    },
    on: {
      "click": _vm.editInfluencer
    }
  }, [_vm._v("Save changes")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec08a2d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/EditInfluencerModal.vue
// module id = 2309
// module chunks = 0